import { API_BASE_URL } from "../config/runtime";

const AUTH_TOKEN_STORAGE_KEY = "ridens_jwt";

let authState = null;
let bootstrapPromise = null;

const normalizeUserFromSession = (payload) => {
  const usuario = payload?.usuario || {};
  const rol = String(payload?.rol || usuario?.rol || '').toLowerCase();
  const rawPuede = payload?.puedeGestionFamiliar;
  let puedeGestionFamiliar = 'false';
  if (rol === 'responsable') {
    puedeGestionFamiliar = 'true';
  } else if (rol === 'paciente') {
    puedeGestionFamiliar = rawPuede === true || rawPuede === 'true' ? 'true' : 'false';
  }
  return {
    userId: String(usuario?.id ?? payload?.id ?? ''),
    userEmail: String(usuario?.email || ''),
    userName: String(usuario?.nombre || ''),
    userApellido: String(usuario?.apellido || ''),
    userRol: rol,
    userType: rol === 'paciente' || rol === 'responsable' ? 'patient' : rol === 'gestor' ? 'gestor' : 'professional',
    auth: rol ? 'true' : '',
    token: '',
    puedeGestionFamiliar,
  };
};

export const initializeAuthSession = async ({ force = false } = {}) => {
  if (bootstrapPromise && !force) return bootstrapPromise;
  bootstrapPromise = (async () => {
    try {
      let tokenFromStorage = "";
      try {
        tokenFromStorage = sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY) || "";
      } catch (_e) {
        tokenFromStorage = "";
      }
      const headers = { "Content-Type": "application/json" };
      if (tokenFromStorage) {
        headers.Authorization = `Bearer ${tokenFromStorage}`;
      }
      const response = await fetch(`${API_BASE_URL}/auth/session`, {
        method: "GET",
        credentials: "include",
        headers,
      });
      if (!response.ok) {
        if (response.status === 401 && tokenFromStorage) {
          try {
            sessionStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
          } catch (_e) {
            /* ignore */
          }
        }
        authState = null;
        return null;
      }
      const payload = await response.json();
      const base = normalizeUserFromSession(payload);
      authState = tokenFromStorage
        ? { ...base, token: tokenFromStorage, auth: base.auth || "true" }
        : base;
      return authState;
    } catch (_error) {
      authState = null;
      return null;
    }
  })();
  return bootstrapPromise;
};

/** Refresca rol y flags de sesión (p. ej. tras crear perfil tutor) sin perder el token en memoria. */
export const refreshAuthSessionFromApi = async () => {
  try {
    let tokenFromStorage = "";
    try {
      tokenFromStorage = sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY) || "";
    } catch (_e) {
      tokenFromStorage = "";
    }
    const prevToken = authState?.token || tokenFromStorage;
    const headers = { "Content-Type": "application/json" };
    if (prevToken) headers.Authorization = `Bearer ${prevToken}`;
    const response = await fetch(`${API_BASE_URL}/auth/session`, {
      method: "GET",
      credentials: "include",
      headers,
    });
    if (!response.ok) return null;
    const payload = await response.json();
    const next = normalizeUserFromSession(payload);
    authState = {
      ...(authState || {}),
      ...next,
      ...(prevToken ? { token: prevToken, auth: next.auth || "true" } : {}),
    };
    return authState;
  } catch (_e) {
    return null;
  }
};

export const getAuthValue = (key) => {
  if (!authState) return null;
  return authState[key] ?? null;
};

/** Responsable siempre; paciente solo si tiene perfil tutor (Responsables.id_paciente_tutor). */
export const authPuedeGestionFamiliar = () => {
  const rol = String(getAuthValue('userRol') || '').toLowerCase();
  if (rol === 'responsable') return true;
  if (rol === 'paciente') return getAuthValue('puedeGestionFamiliar') === 'true';
  return false;
};

export const setAuthSession = (data) => {
  authState = {
    ...(authState || {}),
    ...Object.fromEntries(Object.entries(data || {}).map(([k, v]) => [k, v == null ? '' : String(v)])),
  };
  const t = data?.token != null ? String(data.token).trim() : "";
  if (t) {
    try {
      sessionStorage.setItem(AUTH_TOKEN_STORAGE_KEY, t);
    } catch (_e) {
      /* ignore */
    }
  }
};

export const clearAuthSession = () => {
  authState = null;
  bootstrapPromise = null;
  try {
    sessionStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
  } catch (_e) {
    /* ignore */
  }
};
